module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("nqspx"))).then(() => parcelRequire('1iHdE'));